import { render, staticRenderFns } from "./DashboardProfitChart.vue?vue&type=template&id=0bc7bf19&"
import script from "./DashboardProfitChart.vue?vue&type=script&lang=js&"
export * from "./DashboardProfitChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports